import {Card, Row, Col, Container, Table, Spinner} from "react-bootstrap";
import {Modal, Button}  from "react-bootstrap";
import React, {useEffect} from "react";
import {getMachineStatus} from "../../../lib/api/getMachineStatus";
import {getSerialNumberRecord} from "../../../lib/api/getSerialNumberRecord";
import {useAuth} from "../../auth/AuthProvider";
import {useState} from "react";
import {MachineConnectionStatus} from "./MachineConnectionStatus";
import {LoadingSpinner} from "../../ui/LoadingSpinner";

export const MachineDetail = ({show, onClose, uniqueId, errorLine}) => {
    /*
        show: show status
        onClose: handler called when clos the window
        uniqueId: ID of the machine
        errorLine: if present show error instead of current status, the format is:
            {
                errorTS: ISO format of timestamp
                errorCode: error code mask
                errorFlags: string with active flags
                machineStatus: {
                    "sections": [],
                }
            }
     */


    const {token} = useAuth();
    const [statusData, setStatusData] = useState([]);
    const [isLive, setIsLive] = useState(false);
    const [serialRecord, setSerialRecord] = useState({});

    useEffect(() => {
        if (show === true) {
            if (errorLine === undefined || errorLine === []) {
                setIsLive(true);
                getMachineStatus(token, uniqueId).then( data => {
                    const sections = data.sections;
                    setStatusData(sections);
                });
            } else {
                setStatusData(errorLine.machineStatus.sections);
            }


            getSerialNumberRecord(token, uniqueId).then( data => {
                setSerialRecord(data);
            })

        } else {
            // reset the data
            setSerialRecord({});
            setStatusData([]);
            setIsLive(false);
        }




    }, [show, token, uniqueId])

    return (
        <Modal show={show} onHide={onClose} fullscreen centered>
            <Modal.Header closeButton>
                <Modal.Title>Detail for Machine {uniqueId}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-end">
                    {isLive &&
                        <MachineConnectionStatus uniqueId={uniqueId} classes="d-flex flex-column align-items-end align-right"/>
                    }

                </div>

                <p>
                    <strong>Machine ID:</strong> {uniqueId}<br/>
                    <LoadingSpinner loadingFlag={serialRecord == null }>
                        <strong>Cognito:</strong> {serialRecord["cognitoEmail"]} ({serialRecord["cognitoUsername"]})<br/>
                        <strong>Serial Code TAG:</strong> {serialRecord["tag"]}<br/>
                        <strong>last Provisioned TS:</strong> {serialRecord["provisionedTS"]}<br/>
                    </LoadingSpinner>
                    {errorLine && <>
                        <strong>Error TS:</strong> {errorLine.errorTS}<br/>
                        <strong>Error flags: </strong> {errorLine.errorFlags}
                    </>}

                </p>

                {statusData.map( (section) => (
                    <div>
                        <h2>{section.name}</h2>
                        <Table striped bordered hover responsive>
                            <tr>
                                <th width={"10%"}>Key</th>
                                <th width={"20%"}>Value</th>
                                <th width={"70%"}>Desc</th>
                            </tr>
                        {section.fields.map( (field) => (
                            <tr>
                                <td>{field.key}</td>
                                <td>{field.value}</td>
                                <td>{field.description}</td>
                            </tr>
                        ))}
                        </Table>
                    </div>
                ))}


            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};